import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import React, { useCallback, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import * as Yup from 'yup';

import { BsLockFill } from 'react-icons/bs';

import axios, { AxiosError } from 'axios';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationsErrors';

import Button from '../../components/Button';
import Input from '../../components/Input';

import logo from '../../assets/logo.png';

import { Background, Content } from './styles';

interface ResetPasswordFormData {
  password: string;
  password_confirmation: string;
}

const ResetPassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();
  const location = useLocation();

  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const submitHandler = useCallback(
    async (data: ResetPasswordFormData) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          password: Yup.string().min(6, 'Senha deve ter no mínimo 6 caracteres').required('Senha obrigatória'),
          password_confirmation: Yup.string()
            .oneOf([Yup.ref('password')], 'As senhas devem ser iguais')
            .required('Confirmação de senha obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        // Extract token from URL query parameter
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
          throw new Error('Token não encontrado');
        }

        const apiUrl = process.env.REACT_APP_API_URL;
        await axios.post(`${apiUrl}/password/reset`, {
          token,
          password: data.password,
          password_confirmation: data.password_confirmation,
        });

        addToast({
          type: 'success',
          title: 'Senha redefinida',
          description: 'Sua senha foi alterada com sucesso. Você já pode fazer login.',
        });

        history.push('/');
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          return formRef.current?.setErrors(errors);
        }

        return addToast({
          type: 'error',
          title: 'Erro ao redefinir senha',
          description: (error as AxiosError).response
            ? `${(error as AxiosError).response?.data.message}`
            : error instanceof Error
            ? error.message
            : `${error}`,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, history, location.search],
  );

  return (
    <Background>
      <Content>
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <Form ref={formRef} onSubmit={submitHandler}>
          <h2>Redefinir Senha</h2>
          <p>Digite sua nova senha</p>
          <Input
            icon={BsLockFill}
            color="#0C5C75"
            size={20}
            name="password"
            type="password"
            placeholder="Nova senha"
          />
          <Input
            icon={BsLockFill}
            color="#0C5C75"
            size={20}
            name="password_confirmation"
            type="password"
            placeholder="Confirmar senha"
          />

          <Button name="reset" isLoading={loading}>
            {loading ? 'Redefinindo...' : 'Redefinir senha'}
          </Button>


          <Link to="/">Voltar para login</Link>
        </Form>
      </Content>
    </Background>
  );
};
export default ResetPassword;
